export default __webpack_public_path__ + "static/article-real-stories-saving-spending-lending-ann-7852e4b2b31f06efe6ff071cd6b7b1e7.jpg";